import type { SetState } from '@/store/store';

export type UiSliceProps = {
    header: {
        headerVisible: boolean;
        ribbonVisible: boolean;
        setHeaderVisible: (visible: boolean) => void;
        setRibbonVisible: (visible: boolean) => void;
    };
};

export const headerSlice = ({ set }: SetState<UiSliceProps>): UiSliceProps => ({
    header: {
        headerVisible: true,
        ribbonVisible: true,
        setHeaderVisible: (visible) =>
            set(
                (state) => ({
                    header: {
                        ...state.header,
                        headerVisible: visible
                    }
                }),
                false,
                'ui/setHeaderVisible'
            ),
        setRibbonVisible: (visible) =>
            set(
                (state) => ({
                    header: {
                        ...state.header,
                        ribbonVisible: visible
                    }
                }),
                false,
                'ui/setRibbonVisible'
            )
    }
});
